<template>
  <div style="text-align:right;line-height:30px;margin-right:119px;">
    <p>
      {{$t('mis.rebateComponents.subtotal')}}：{{$t('mis.rewardDealList.currentRebete')}}<span>{{sub.amount}}</span>，{{$t('mis.rewardDealList.correctionRebete')}}<span>{{sub.correctionAmount}}</span>，{{$t('mis.rewardDealList.finalRebete')}}<span>{{sub.finalAmount}}</span>
    </p>
    <p>
      {{$t('mis.rebateComponents.total')}}：{{$t('mis.rewardDealList.currentRebete')}}<span>{{total.amount}}</span>，{{$t('mis.rewardDealList.correctionRebete')}}<span>{{total.correctionAmount}}</span>，{{$t('mis.rewardDealList.finalRebete')}}<span>{{total.finalAmount}}</span>
    </p>
  </div>
</template>

<script>
    import DateUtil from '@/utils/IM/tradeDataUtil.js'

    export default {
        props: ["tableData", 'totalize'],
        data() {
            return {
            };
        },
        computed: {
            sub: {
                get() {
                    let obj = {};
                    let amount = 0, finalAmount = 0, correctionAmount = 0;
                    this.tableData.forEach((item, index) => {
                        amount = DateUtil.accAdd(amount, item.currentRebete);
                        correctionAmount = DateUtil.accAdd(correctionAmount, item.correctionRebete);
                        finalAmount = DateUtil.accAdd(finalAmount, item.finalRebete);
                    });
                    obj.amount = amount;
                    obj.correctionAmount = correctionAmount;
                    obj.finalAmount = finalAmount;
                    return obj;
                }
            },
            total: {
                get() {
                    let obj = {};
                    obj.amount = this.totalize.amount;
                    obj.correctionAmount = this.totalize.correctionAmount;
                    obj.finalAmount = this.totalize.finalAmount;
                    return obj;
                }
            }
        },
        methods: {
        },
        mounted() {
        }
    };
</script>
